import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type DashboardPeriod = "month" | "quarter" | "year"

export type DashboardDailyPointDTO = {
  date: string
  label: string
  documents_count: number
  total_qty: number
  total_value_netto: number
  total_value_brutto: number
}

export type DashboardDocumentTotalsDTO = {
  documents_count: number
  total_qty: number
  total_value_netto: number
  total_value_brutto: number
  daily_points?: DashboardDailyPointDTO[]
}

export type DashboardPurchaseOrderRealizationDTO = {
  orders_count: number
  realized_count: number
  partially_realized_count: number
  requested_qty: number
  realized_qty: number
  realization_percent: number
}

export type DashboardSalesOfferRealizationDTO = {
  offers_count: number
  realized_offers_count: number
  offered_qty: number
  released_qty: number
  realization_percent: number
}

export type DashboardProductionDailyPointDTO = {
  date: string
  label: string
  produced_qty: number
  production_value_netto: number
}

export type DashboardProductionDTO = {
  open_orders_count: number
  open_target_qty: number
  open_produced_qty: number
  open_progress_percent: number
  closed_orders_count: number
  closed_produced_qty: number
  closed_production_value_netto: number
  daily_points?: DashboardProductionDailyPointDTO[]
}

export type OperationalDashboardResponseDTO = {
  period: DashboardPeriod
  period_start: string
  period_end: string
  period_label: string
  purchases: DashboardDocumentTotalsDTO
  sales: DashboardDocumentTotalsDTO
  purchase_order_realization: DashboardPurchaseOrderRealizationDTO
  sales_offer_realization: DashboardSalesOfferRealizationDTO
  production: DashboardProductionDTO
}

// getOperationalDashboard loads the operational WMS dashboard endpoint.
export function getOperationalDashboard(
  period: DashboardPeriod,
): CancelablePromise<OperationalDashboardResponseDTO> {
  return __request(OpenAPI, {
    method: "GET",
    url: "/v1/dashboard/operational",
    query: { period },
  })
}
